import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Button, Table, message, Form, Spin, Space, Row, Col, Tooltip, Checkbox, Card, Typography, Input } from 'antd';
import {Link, useNavigate} from "react-router-dom";
import {IoReload} from "react-icons/io5";
import {EnvironmentOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import _ from "lodash";

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const Address = () => {
    // Limpia user_mod si existe
    if (sessionStorage.getItem('user_mod')) {
        sessionStorage.removeItem('user_mod');
    }

    const { t } = useTranslation();
    const [bottom, setBottom] = useState('bottomCenter');
    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [checked, setChecked] = useState(false);  // Inicializado en false para desmarcar inicialmente
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t('global.loading'));
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const navigate = useNavigate();

    const [tableKey, setTableKey] = useState(0);

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    // Recarga al montar y cada vez que cambie `checked`
    useEffect(() => {
        recargar();
    }, [checked]);

    const handleCheckboxChange = (e) => {
        setChecked(e.target.checked);
    };

    const filterData = dataArr => formatter => dataArr.map(item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const columns = [
        {
            title: <p style={{ margin: 0, fontSize: 15, fontWeight: 'bold', color: '#2c3e50', fontFamily: 'Roboto, sans-serif', textShadow: '1px 1px 2px rgba(0,0,0,0.2)' }}>{t('address.col_address')}</p>,
            dataIndex: 'direccion', width: 300,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.direccion), _.isEqual),
            onFilter: (value, record) => record.direccion.startsWith(value),
        },
        {
            title: <p style={{ margin: 0, fontSize: 15, fontWeight: 'bold', color: '#2c3e50', fontFamily: 'Roboto, sans-serif', textShadow: '1px 1px 2px rgba(0,0,0,0.2)' }}>{t('address.col_code')}</p>,
            dataIndex: 'codigo', width: 100,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.codigo), _.isEqual),
            onFilter: (value, record) => record.codigo.startsWith(value),
        },
        {
            title: <p style={{ margin: 0, fontSize: 15, fontWeight: 'bold', color: '#2c3e50', fontFamily: 'Roboto, sans-serif', textShadow: '1px 1px 2px rgba(0,0,0,0.2)' }}>{t('address.col_invoicestate')}</p>,
            dataIndex: 'estadoinvoice', width: 120,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.estadoinvoice), _.isEqual),
            onFilter: (value, record) => record.estadoinvoice.startsWith(value),
        },
        {
            title: t('address.col_latitude'),
            dataIndex: 'latitude',
            width: 120,
            filterSearch: true,
            filters: _.uniqWith(
              filterData(data)(i =>
                i.latitude != null && i.latitude !== ''
                  ? String(i.latitude)
                  : '-'
              ),
              _.isEqual
            ),
            onFilter: (value, record) => {
              if (value === '-') {
                return record.latitude == null || record.latitude === '';
              }
              return record.latitude != null &&
                     String(record.latitude).startsWith(value);
            },
            render: latitude =>
              latitude != null && latitude !== ''
                ? String(latitude)
                : '-',
          },
          {
            title: t('address.col_longitude'),
            dataIndex: 'longitude',
            width: 120,
            filterSearch: true,
            filters: _.uniqWith(
              filterData(data)(i =>
                i.longitude != null && i.longitude !== ''
                  ? String(i.longitude)
                  : '-'
              ),
              _.isEqual
            ),
            onFilter: (value, record) => {
              if (value === '-') {
                return record.longitude == null || record.longitude === '';
              }
              return record.longitude != null &&
                     String(record.longitude).startsWith(value);
            },
            render: longitude =>
              longitude != null && longitude !== ''
                ? String(longitude)
                : '-',
          },{
            title: <p style={{
              margin: 0,
              fontSize: 15,
              fontWeight: 'bold',
              color: '#2c3e50',
              fontFamily: "'Roboto', sans-serif",
              textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
            }}>
              {t('invoice.col_priority')}
            </p>,
            dataIndex: 'prioridad',
            key: 'prioridad',
            width: 100,
            // 1) Creamos un Set directamente sobre data.map → Array → ordenamos → mapeamos a {text, value}
            filters: Array.from(new Set(data.map(item => item.prioridad)))
                          .sort((a, b) => a - b)
                          .map(p => ({ text: String(p), value: p })),
            // 2) Comparamos por igualdad estricta (value es un número)
            onFilter: (value, record) => record.prioridad === value,
            // 3) Orden numérico puro
            sorter: (a, b) => a.prioridad - b.prioridad,
            // 4) Opcional: asegurar que pinte como texto
            render: prioridad => String(prioridad)
          }
    ];

    const recargar = () => {
        setSearchValue('');
        setTableKey(old => old + 1);
        setSpinning(true);
        setSelectedRowKeys([]);

        Axios.post("sd/getInvoicesAddress", { georeferencia: checked ? 1 : 0 }, { headers })
             .then(response => {
                 setSpinning(false);
                 const aux = (response.data.data || []).map(inv => ({
                     key: inv.idinvoice,
                     idinvoice: inv.idinvoice,
                     direccion: inv.direccion,
                     latitude: inv.latitude,
                     longitude: inv.longitude,
                     codigo: inv.codigo,
                     estadoinvoice: inv.estadoinvoice,
                     prioridad: inv.prioridad
                 }));
                 setData(aux);
                 setOriginal(aux);
             })
             .catch(() => {
                 setSpinning(false);
                 messageApi.error(t('global.errorFetch'));
             });
    };

    const filterLocal = value => {
        if (!value) {
            setData(original);
        } else {
            setData(original.filter(o => o.direccion.toUpperCase().includes(value.toUpperCase())));
        }
    };

    const onSearch = value => filterLocal(value);
    const onSelectChange = newKeys => setSelectedRowKeys(newKeys);

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size="large">
                {/* Header Principal */}
                <div style={{
                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '12px',
                    color: 'white',
                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}>
                    <Row align="middle">
                        <Col xs={24} md={16}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <EnvironmentOutlined style={{ fontSize: '24px' }} />
                                <div>
                                    <Typography.Title level={4} style={{ color: 'white', margin: 0, marginBottom: '2px' }}>
                                        {t('address.title')}
                                    </Typography.Title>
                                    <Typography.Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}>
                                        Gestión de direcciones
                                    </Typography.Text>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} md={8} style={{ textAlign: 'right' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div style={{
                                    background: 'rgba(255,255,255,0.15)',
                                    borderRadius: '4px',
                                    padding: '2px 6px',
                                    backdropFilter: 'blur(10px)'
                                }}>
                                    <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                                        Total: {data.length}
                                    </Typography.Text>
                                </div>
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '4px',
                                    padding: '4px 6px',
                                    backdropFilter: 'blur(10px)'
                                }}>
                                    <Typography.Text style={{ color: 'white', fontSize: '10px' }}>
                                        {checked ? 'Con coord.' : 'Todas'}
                                    </Typography.Text>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                {contextHolder}

                {/* Panel de Herramientas */}
                <Card
                    style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none',
                        marginBottom: '12px'
                    }}
                    styles={{ body: { padding: '12px' } }}
                >
                    <Row justify="space-between" align="middle" gutter={[12, 12]}>
                        <Col xs={24} sm={12} md={8}>
                            <Space>
                                <Checkbox
                                    checked={checked}
                                    onChange={handleCheckboxChange}
                                    style={{
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Solo con coordenadas
                                </Checkbox>
                            </Space>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Space style={{ width: '100%', justifyContent: 'center' }}>
                                <Tooltip title={t('vehicletype.update')}>
                                    <Button
                                        type="primary"
                                        icon={<IoReload />}
                                        onClick={recargar}
                                        size="small"
                                        style={{
                                            background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                            borderColor: '#253289',
                                            borderRadius: '8px',
                                            height: '32px',
                                            fontWeight: '500',
                                            boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                        }}
                                    >
                                        {t('global.reload')}
                                    </Button>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                </Card>

                {/* Tabla de Direcciones */}
                <Card
                    style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }}
                    styles={{ body: { padding: '0' } }}
                    title={
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 16px',
                            borderBottom: '1px solid #f0f0f0'
                        }}>
                            <Typography.Title level={5} style={{ margin: 0, color: '#253289' }}>
                                Lista de Direcciones
                            </Typography.Title>
                            <Space>
                                <Input.Search
                                    placeholder={t('address.search')}
                                    style={{ width: '160px' }}
                                    size="small"
                                    value={searchValue}
                                    onSearch={onSearch}
                                    onChange={e => { setSearchValue(e.target.value); filterLocal(e.target.value); }}
                                    allowClear
                                />
                            </Space>
                        </div>
                    }
                >
                    <Table
                        key={tableKey}
                        size="small"
                        bordered={false}
                        columns={columns}
                        dataSource={data}
                        onChange={() => {}}
                        scroll={{ x: 1000 }}
                        style={{
                            background: 'white',
                            borderRadius: '8px'
                        }}
                        pagination={{
                            position: [bottom],
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10','20','50','100'],
                            onChange: (page, size) => setPagination({ current: page, pageSize: size }),
                            showTotal: total => `Total ${total} elementos`,
                            style: {
                                padding: '8px 12px',
                                borderTop: '1px solid #f0f0f0'
                            }
                        }}
                    />
                </Card>
            </Spin>
        </div>
    );
};

export default Address;
